export default {
  page_title: '事業内容 | AIX JAPAN – AIコンサルティング・DX推進・IT関連',
  page_desc: 'AIX JAPANの4つの事業領域：AIX事業（AIX コンサルティング・AIX マネージャー・AIX トレーニング・AIエージェント開発）、事業開発、IT関連、自社サービス。',
  hero_label: 'Service',
  hero_title: '事業内容',
  hero_subtitle: 'AIとあらゆる事業領域を掛け合わせ、\n企業変革を共に実現します。',
  intro_label: 'OUR SERVICES',
  intro_title: '4つの専門領域で、\n企業の変革と成長を支援します',
  intro_desc: 'AIX JAPANは「AIX事業」「事業開発」「IT関連」「自社サービス」の4領域において、\n戦略立案から実行・運用まで一貫したサービスを提供しています。\n貴社の課題・フェーズに合わせて最適なチームが伴走します。',
  cat_aix_en: 'AIX Business',
  cat_aix_ja: 'AIX事業',
  cat_aix_desc: 'AIと事業（X）を掛け合わせ、企業変革を戦略から実行まで一貫してご支援します。',
  cat_bizdev_en: 'Business Development',
  cat_bizdev_ja: '事業開発',
  cat_bizdev_desc: 'AIによる効率化で生まれた余力を、新たな事業価値の創出へ。市場分析からPoC・事業化まで、AIX事業と相互に補完し合う戦略・新規事業支援です。',
  cat_it_en: 'IT Solutions',
  cat_it_ja: 'IT関連',
  cat_it_desc: 'AI領域に限らず、システム開発・インフラ整備・セキュリティ対策まで。AI活用の土台となる安心・安全なIT基盤を確かな技術力で提供します。',
  cat_foundation_en: 'CAPABILITIES',
  cat_foundation_ja: 'AIXを支える基盤ケイパビリティ',
  cat_foundation_desc: 'AIで生まれた余力を新規事業へ、その新規事業もAIでスピーディーに。AIX事業と両輪で企業変革を完結させる、事業開発とIT基盤の2領域です。',
  cat_foundation_cta: 'この領域のご相談はこちら',
  cat_own_en: 'Own Service',
  cat_own_ja: '自社サービス',
  cat_own_desc: 'AIX JAPANが自社開発した生成AIプラットフォーム。複数のAIモデル・機能をひとつのツールに統合し、企業のAI活用を加速します。',
  svc_consulting_name: 'AIX コンサルティング',
  svc_consulting_desc: 'AI戦略の立案からDX推進・新規AI事業立ち上げまで、経営レベルでのAI活用設計から現場定着まで一貫して伴走します。',
  svc_manager_name: 'AIX マネージャー',
  svc_manager_desc: 'AI導入後の運用・管理・業務自動化・データ活用基盤の構築など、組織のデジタル変革を継続的に支援します。',
  svc_training_name: 'AIX トレーニング',
  svc_training_desc: 'AIリテラシーの底上げから専門AI人材育成まで、貴社の業種・組織に合わせたオーダーメイド研修プログラムを提供します。',
  svc_agent_name: 'AIエージェント開発',
  svc_agent_desc: '業務自動化・カスタマーサポート・データ処理などの課題に対し、実務に即したAIエージェントを設計・開発・実装します。',
  svc_strategy_name: '戦略コンサルティング',
  svc_strategy_desc: '市場分析・競合調査・ビジネスモデル設計など、企業の持続的成長を実現するための経営戦略を立案します。',
  svc_newbiz_name: '新規事業開発コンサルティング',
  svc_newbiz_desc: '新規事業の企画・検証・立ち上げを全フェーズで支援。市場調査からPoC設計、事業化まで一気通貫で対応します。',
  svc_itcon_name: 'ITコンサルティング',
  svc_itcon_desc: '現状のIT環境を診断し、最適なIT戦略・アーキテクチャ設計・ベンダー選定を含む包括的な支援を提供します。',
  svc_dev_name: 'システム開発',
  svc_dev_desc: '業務システム・Webアプリ・APIなど、要件定義から設計・開発・テスト・リリースまでワンストップで対応します。',
  svc_infra_name: 'インフラ設計構築',
  svc_infra_desc: 'クラウド・オンプレミス・ハイブリッド構成など、事業規模・要件に最適なインフラ設計・構築・移行を支援します。',
  svc_ops_name: '運用保守・品質管理・セキュリティ',
  svc_ops_desc: 'システムの安定稼働を維持する運用保守から、品質管理体制の整備、情報セキュリティ対策まで一括でご対応します。',
  svc_aitool_name: '生成AI All In One Tool',
  svc_aitool_desc: 'GPT-4o・Claude・Gemini対応のマルチAIチャット、画像生成、音声文字起こし、ドキュメント作成、データ分析、AIエージェントを一元提供するSaaSプラットフォームです。',
  read_more: '詳しく見る',
};